export default __webpack_public_path__ + "static/media/Tasset of Vengeful Zeal.dc32d53c.jpg";